import { useState } from 'react';
import toast from 'react-hot-toast';

export const useCopyToClipboard = () => {
  const [copiedText, setCopiedText] = useState<string | null>(null);

  const copy = async (text: string): Promise<boolean> => {
    if (!navigator?.clipboard) {
      toast.error('الحافظة غير مدعومة في هذا المتصفح');
      return false;
    }

    try {
      await navigator.clipboard.writeText(text);
      setCopiedText(text);
      toast.success('تم النسخ بنجاح');
      return true;
    } catch (error) {
      toast.error('فشل النسخ');
      setCopiedText(null);
      return false;
    }
  };

  return { copiedText, copy };
};